import { createContext, useContext } from "react";
import { MapEditorState } from "./MapEditorContext.types";

export const MapEditorContext = createContext<MapEditorState | null>(null);

export const useMapEditor = () => {
  const context = useContext(MapEditorContext);
  if (!context) {
    throw new Error("useMapEditor must be used within a MapEditorProvider");
  }
  return context;
};
